/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_Th_NameInputs */

const tr_cerez_s3_th_name = /** @type {(inputs: Cerez_S3_Th_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çerez Adı`)
};

const en_cerez_s3_th_name = /** @type {(inputs: Cerez_S3_Th_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie name`)
};

const de_cerez_s3_th_name = /** @type {(inputs: Cerez_S3_Th_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie-Name`)
};

const ru_cerez_s3_th_name = /** @type {(inputs: Cerez_S3_Th_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Название файла cookie`)
};

/**
* | output |
* | --- |
* | "Cookie name" |
*
* @param {Cerez_S3_Th_NameInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_th_name = /** @type {((inputs?: Cerez_S3_Th_NameInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_Th_NameInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_th_name(inputs)
	if (locale === "de") return de_cerez_s3_th_name(inputs)
	if (locale === "ru") return ru_cerez_s3_th_name(inputs)
	return tr_cerez_s3_th_name(inputs)
});